module.exports = __webpack_public_path__ + "static/media/intro_mob_png.d29cdacd.png";